import { SortDirection } from '@elio/shared/models';
import { compareLocaleDates, compareLocaleDateTimes, isLocalDate, isLocalDateTime } from './date.utils';

export const removeDuplicateForKeyInArrayOfObject = <T, K extends keyof T>(array: T[], key: K): T[] =>
  array.reduce((acc, current) => {
    const x = acc.find((item) => item[key] === current[key]);
    if (!x) {
      return acc.concat([current]);
    } else {
      return acc;
    }
  }, [] as T[]);

export const removeDuplicate = <T>(array: T[]): T[] => Array.from(new Set(array));

export const sortArrayByProperty = <T>(array: T[], property: keyof T, sortDirection: SortDirection): T[] => {
  return [...array].sort((data1, data2) => {
    const value1 = data1[property];
    const value2 = data2[property];
    let comparison;

    if (!value1 && !value2 && typeof value1 !== 'string' && typeof value2 !== 'string') {
      comparison = 0;
    } else if (!value1 && typeof value1 !== 'string') {
      comparison = -1;
    } else if (!value2 && typeof value2 !== 'string') {
      comparison = 1;
    } else if (typeof value1 === 'string' && typeof value2 === 'string') {
      comparison = value1.localeCompare(value2);
    } else if (isLocalDate(value1) && isLocalDate(value2)) {
      comparison = compareLocaleDates(value1, value2);
    } else if (isLocalDateTime(value1) && isLocalDateTime(value2)) {
      comparison = compareLocaleDateTimes(value1, value2);
    } else {
      comparison = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
    }

    return sortDirection * comparison;
  });
};
